import { useState, useEffect } from "react";

/**
 * Resuelve el breakpoint correspondiente según los píxeles de ancho.
 */
const getScreenTypeFromWidth = (width) => {
  if (width < 700) return "mobile";
  if (width < 1200) return "tablet";
  return "desktop";
};


/**
 * Custom Hook para gestionar el estado adaptativo de la pantalla.
 * @param {string|null} deviceView - Fuerza una vista fija si viene desde el Playground.
 */
export const useScreenType = (deviceView) => {
  const [screenType, setScreenType] = useState(deviceView);

  useEffect(() => {
    // Si el Playground nos pasa una vista fija (ej: "mobile"), no escuchamos el resize del navegador
    if (deviceView) return undefined;

    const handleResize = () => {
      setScreenType(getScreenTypeFromWidth(window.innerWidth));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [deviceView]);

  // Si el usuario cambia activamente de dispositivo en el Backoffice, mutamos el estado inmediatamente
  useEffect(() => {
    if (deviceView) {
      setScreenType(deviceView);
    }
  }, [deviceView]);

  return screenType;
};

export default useScreenType;
